import React, { useEffect, useState } from "react";
import { useFormContext } from 'react-hook-form'
import styles from './MessengersInput.module.scss'
import cn from 'classnames'
import { Country, Lang } from "../../../types/common-types";
import { State } from '../../../state-actions-reducers'
import accountForm from "../../../content/account-form";
import MessengersItem from "../MessengersItem/MessengersItem";
import SelectInput from "../SelectInput/SelectInput";
import AddButton from "../../../shared/Buttons/AddButton";
import { messengersLinksOptions } from "../../../content/messengersLinks";

interface Props {
    lang: Lang;
    allCitizenships: Country[]
    phoneNumbers: string[]
}

function MessengersInput({ lang, allCitizenships, phoneNumbers }: Props) {
    const { watch, setValue, formState: { errors } } = useFormContext<State>()
    const state = watch()

    const CommunicationTypeOptions = [
        { label: accountForm.voiceAndText, value: '0' },
        { label: accountForm.voice, value: '1' },
        { label: accountForm.text, value: '2' },
    ];
    const CommunicationTimeOptions = [
        { label: accountForm.morning, value: '1' },
        { label: accountForm.day, value: '2' },
        { label: accountForm.evening, value: '3' },
        { label: accountForm.night, value: '4' }
    ];
    const [messengersCount, setMessengersCount] = useState(1)
    const messengers = () => {
        let list = []
        for (let i = 0; i < messengersCount; i++) {
            list.push(
                <MessengersItem
                    key={`messenger-${i}`}
                    lang={lang}
                    index={i}
                    disabled={(state.messengers?.[i]?.type === 'WhatsApp' && state.whatsappCheck && !!state.messengers?.[i]?.isCheck) || (state.messengers?.[i]?.type === 'Telegram' && state.telegramCheck && !!state.messengers?.[i]?.isCheck)}
                    allCitizenships={allCitizenships}
                    deleteHandler={() => {
                        if (state.messengers?.[i]?.type) {
                            setValue('messengers', state.messengers.filter((e, index) => index !== i) as any, { shouldDirty: true })
                        } else {
                            setMessengersCount(messengersCount - 1)
                        }
                    }}
                />
            )
        }
        return list
    }

    useEffect(() => {
        state.messengers.length > 0 && setMessengersCount(state.messengers.length)
    }, [state.messengers])

    useEffect(() => {
        let updatedMessengers = state.messengers
        if (state.whatsappCheck) {
            updatedMessengers = updatedMessengers.find((e) => e.type === "WhatsApp" && e.isCheck)
                ? updatedMessengers.map((item) => {
                    return (item.type === "WhatsApp" && item.isCheck) ? {
                        type: "WhatsApp",
                        description: "WhatsApp",
                        link: `https://wa.me/${phoneNumbers[0] ? phoneNumbers[0]?.replace(/[\D]/gim, '') : ''}`,
                        isCheck: true
                    } : item
                }) : updatedMessengers.concat(
                    {
                        type: "WhatsApp",
                        description: "WhatsApp",
                        link: `https://wa.me/${phoneNumbers[0] ? phoneNumbers[0]?.replace(/[\D]/gim, '') : ''}`,
                        isCheck: true
                    },
                )
            setValue('messengers', updatedMessengers as any, { shouldDirty: true })
        }
        if (state.telegramCheck) {
            updatedMessengers = updatedMessengers.find((e) => e.type === "Telegram" && e.isCheck)
                ? updatedMessengers.map((item) => {
                    return (item.type === 'Telegram' && item.isCheck) ? {
                        type: "Telegram",
                        description: "Telegram",
                        link: `https://t.me/+${phoneNumbers[0] ? phoneNumbers[0]?.replace(/[\D]/gim, '') : ''}`,
                        isCheck: true
                    } : item
                }) : updatedMessengers.concat(
                    {
                        type: "Telegram",
                        description: "Telegram",
                        link: `https://t.me/+${phoneNumbers[0] ? phoneNumbers[0]?.replace(/[\D]/gim, '') : ''}`,
                        isCheck: true
                    },
                )
            setValue('messengers', updatedMessengers as any, { shouldDirty: true })
        }
    }, [phoneNumbers])
    return (
        <>
            <div className="row">
                <div className={cn("col-12 col-xs-12", styles.messengersTitle)}>
                    <h3>{accountForm.stepTwoMessengerTitle[lang]}</h3>
                    <span className={styles.description}>{accountForm.stepTwoMessengerDescription[lang]}</span>
                </div>
            </div>
            {messengers()}
            {state.messengers.length < messengersLinksOptions.length && <div className="row">
                <div className="col-6 col-xs-12">
                    <div className={styles.addButtonBox} onClick={() => {
                        setMessengersCount(messengersCount + 1)
                    }}>
                        <AddButton />
                        <span>{accountForm.messengersButton[lang]}</span>
                    </div>
                </div>
            </div>}

            <div className="row">
                <div className="col-6 col-xs-12">
                    <SelectInput
                        name={'preferredCommunicationType'}
                        options={CommunicationTypeOptions}
                        onChange={(e) => {
                            setValue('preferredCommunicationType', e, { shouldDirty: true })
                            if (+e === 2) setValue('preferredCommunicationTime', '0', { shouldDirty: true })
                        }}
                        value={
                            CommunicationTypeOptions.find((e) => {
                                return e.value === state.preferredCommunicationType
                            })?.value ?? ''
                        }
                        lang={lang}
                        content={accountForm.preferredCommunicationType}
                        noOptionsMessage={
                            accountForm.additionalLinksDescription.placeholder
                        }
                        valid={!errors.preferredCommunicationType}
                    />
                </div>
                {+(state?.preferredCommunicationType ?? 0) !== 2 && <div className="col-6 col-xs-12">
                    <SelectInput
                        disabled={!state.preferredCommunicationType.length}
                        name={'preferredCommunicationTime'}
                        options={CommunicationTimeOptions}
                        onChange={(e) => {
                            setValue('preferredCommunicationTime', e, { shouldDirty: true })
                        }}
                        lang={lang}
                        value={
                            CommunicationTimeOptions.find((e) => {
                                return e.value === state.preferredCommunicationTime
                            })?.value ?? ''
                        }
                        content={accountForm.preferredCommunicationTime}
                        noOptionsMessage={
                            accountForm.additionalLinksDescription.placeholder
                        }
                        valid={!errors.preferredCommunicationTime}
                    />
                </div>}
            </div>
        </>
    );
}

export default MessengersInput;
